// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"9764d251","845":"67623664"}[chunkId] + ".chunk.js";
};